angular
  .module('bb.listing_search')
  .factory('ListingSearchService', ListingSearchService);

ListingSearchService.$inject = ['$resource'];
function ListingSearchService($resource) {
  const Listings = $resource('/listing/:type/:pageNumber');

  const TeamListings = $resource('/listing/team/v2/:pageNumber');

  const Favorites = $resource('/favorite');

  const Locations = $resource('/org/locations');

  const Statuses = $resource('/statuses');

  const Team = $resource(
    '/team/batch',
    {},
    { get: { method: 'GET', isArray: true } },
  );

  function searchListings(searchParams, hasNewListingsSearchAPI = false) {
    if (searchParams.searchType === 'team' && hasNewListingsSearchAPI) {
      return TeamListings.get(searchParams).$promise;
    }

    return Listings.get(searchParams).$promise;
  }

  function getFavorites() {
    return Favorites.query().$promise;
  }

  function getLocations() {
    return Locations.get().$promise;
  }

  function getStatuses() {
    return Statuses.query().$promise;
  }

  function getTeamsByIds(teamIds) {
    return Team.get({ teamIds }).$promise;
  }
  return {
    searchListings,
    getFavorites,
    getLocations,
    getStatuses,
    getTeamsByIds,
  };
}

export {};
